export const SIZE_CHANGED = 'SIZE_CHANGED';
export const sizeChanged = (newSize) => ({
  type: SIZE_CHANGED,
  size: newSize,
});
